export default __webpack_public_path__ + "static/media/Sanskirt-min.cb435f89.webp";